import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import { storageGet, storageRemove, storageSet } from "../utils/storage";
import { SET_ACTIVE_LISTING_ID } from "./actionTypes";
import rootReducer from "./reducers";

const composeEnhancers =
  /** @type {typeof compose} */ (
    /** @type {any} */ (window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) || compose;

// Build preloaded state from sessionStorage so the listing UUID survives
// a page reload — critical for the Stripe checkout redirect round-trip.
const SESSION_STORAGE_KEY = "currentListingId";
const preloadedActiveListingId = storageGet(SESSION_STORAGE_KEY);

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

// Hydrate the reducer from sessionStorage if we picked up a UUID above.
// Doing this via an action (rather than preloadedState) keeps the
// reducer's initial state contract simple and still produces the same
// Redux devtools trail.
if (preloadedActiveListingId) {
  store.dispatch({ type: SET_ACTIVE_LISTING_ID, payload: preloadedActiveListingId });
}

// Mirror activeListingId back to sessionStorage on every change so the
// Stripe redirect (window.location.href = stripe_url, back via webhook)
// can still find it when the SPA re-boots.
let lastMirroredId = preloadedActiveListingId;
store.subscribe(() => {
  const id = store.getState().listings.activeListingId;
  if (id === lastMirroredId) return;
  lastMirroredId = id;
  if (id) {
    storageSet(SESSION_STORAGE_KEY, id);
  } else {
    storageRemove(SESSION_STORAGE_KEY);
  }
});

export default store;
